import { CalendarDaysIcon, ShareIcon } from '@heroicons/react/24/outline';
import { EventData } from '../../types';


interface EventHeaderProps {
  eventData: EventData;
  eventStatus: 'upcoming' | 'live' | 'ended';
  handleShare: (type: 'link' | 'image' | 'qr') => void;
  countdown: {
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
  } | null;
  currentDay: number;
}

const EventHeader = ({
  eventData,
  eventStatus,
  handleShare,
  countdown,
  currentDay
}: EventHeaderProps) => {
  const CountdownTimer = () => (
    <div className="mt-4 bg-blue-50 p-4 rounded-lg">
      <h3 className="text-sm font-semibold text-blue-800 mb-2">EVENT STARTS IN</h3>
      <div className="flex gap-4 text-2xl font-bold text-blue-900">
        {Object.entries(countdown!).map(([key, value]) => (
          <div key={key} className="flex flex-col items-center">
            <span>{value}</span>
            <span className="text-sm font-normal">{key.charAt(0).toUpperCase() + key.slice(1)}</span>
          </div>
        ))}
      </div>
    </div>
  );

  const EventStatusBadge = () => {
    if (eventStatus === 'live') {
      return (
        <div className="mt-4 bg-green-100 p-3 rounded-lg flex items-center gap-2">
          <div className="w-2 h-2 bg-green-600 rounded-full animate-pulse"></div>
          <span className="text-green-800 font-medium">
            Live Now - Day {currentDay} of {eventData?.days.length}
          </span>
        </div>
      );
    }
    if (eventStatus === 'ended') {
      return (
        <div className="mt-4 bg-red-100 p-3 rounded-lg flex items-center gap-2">
          <div className="w-2 h-2 bg-red-600 rounded-full"></div>
          <span className="text-red-800 font-medium">Event Ended</span>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-xl shadow-sm p-6 mb-8">
      <div className="flex justify-between items-start">
        <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-3">
          <CalendarDaysIcon className="w-8 h-8 text-blue-600" />
          {eventData.title}
        </h1>
        <button
          onClick={() => handleShare('link')}
          className="p-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
        >
          <ShareIcon className="w-6 h-6" />
        </button>
      </div>
      {eventStatus === 'upcoming' && countdown && <CountdownTimer />}
      <EventStatusBadge />
    </div>
  );
};
export default EventHeader